import {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {IsAuthnticated} from "../tools/AuthCheck";

export const AuthProvider = ({routeName, children, level}) => {
    const location = useLocation();
    const navigate = useNavigate();
     
    useEffect(() => {
                 
         switch (level) {
            case "auth":
            case "public":
            case "form":
                break;
            case "sign":
                if (IsAuthnticated()) {
                    navigate("/information  ", {replace: true});
                }
                break;
            default:
                break;
        }
        if (routeName !== "notfound" &&level !=="public" &&level !=="sign" && !IsAuthnticated() ) {
            navigate("/login", {replace: true});
        }
        
    }, [location.pathname]);
    return children;
};
